// extracted by mini-css-extract-plugin
module.exports = {"amountRow":"Amount_amountRow__1iE1e","amount":"Amount_amount__1tTci","tip":"Amount_tip__tAsqr","tipHeader":"Amount_tipHeader__1pUyP","tipsWrap":"Amount_tipsWrap__3Qygb"};